import React, { useState } from "react";
import { Form, Input, Button, Flex, Checkbox } from "antd";
import { useNavigate } from "react-router-dom";
import {
  CloseOutlined,
  LockOutlined,
  UserOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { TResponseModel, TUser } from "../../types/config";
import EncryptUtils from "../../utils/encrypt";
import useFetch from "../../hooks/useFetch";
import { ApiSignin, GetMenuHierarchyList } from "../../utils/api.constant";
import { eResultCode } from "../../utils/enum";
import useToast from "../../hooks/useToast";
import AuthUtil from "../../utils/auth";
import { ToastOpen, ToastType } from "../../state/toast/slice";
import Utils from "../../utils";
import styles from "./auth.module.css";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { post } = useFetch();
  const { showToast, onShowToast } = useToast();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onFinish = async (values: TUser) => {
    try {
      setIsLoading(true);
      const password = EncryptUtils.encrypt(values.password as string);
      // Prepare payload for API request
      const payload = {
        // data: {
        // username: "mayankmod",
        userName: values.emailId,
        password: password,
        loginMode: 1,
        // },
      };

      // Make API request for sign-in
      const response: TResponseModel = await post(ApiSignin, payload);

      // Handle API response
      const { dataResponse, authToken } = response;
      const { returnCode, description } = dataResponse;

      if (returnCode === eResultCode.SUCCESS) {
        AuthUtil.setToken(authToken as string);
        AuthUtil.activeLoggedUserService();
        // Display success toast
        onShowToast({
          type: ToastType.success,
          title: <CheckOutlined />,
          position: ToastOpen.centerTop,
          content: description,
        });
        setIsLoading(false);
        // Redirect to dashboard after a brief delay
        setTimeout(async () => {
          const menus = await getMenuHierarchyList();
          Utils.redirectUrl(menus?.[0]?.entityUrl);
        }, 700);
      } else {
        // Display error toast
        setIsLoading(false);
        onShowToast({
          type: ToastType.error,
          title: <CloseOutlined />,
          position: ToastOpen.centerTop,
          content: dataResponse.description,
        });
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Function to fetch menu hierarchy list from the server
  const getMenuHierarchyList = async () => {
    try {
      const requestPayload = {
        data: {
          renderMenuRoleWise: true,
        },
      };
      const response = await post(GetMenuHierarchyList, requestPayload);
      const { data, dataResponse } = response;
      const { returnCode, description } = dataResponse;
      if (returnCode === eResultCode.SUCCESS) {
        return data;
      } else {
        console.error(`Error while fetching menu hierarchy: ${description}`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onClickRegister = () => {
    navigate("/register");
  };
  const onClickForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <div className={styles.parentWrapper}>
      <Form
        name="login"
        initialValues={{ remember: true }}
        style={{}}
        onFinish={onFinish}
        size="middle"
        autoComplete="off"
      >
        <div className={styles.formHeader}>
          <h1>Sign In</h1>
        </div>
        <Form.Item
          name="emailId"
          rules={[{ required: true, message: "Please enter your Email Id" }]}
        >
          <Input
            autoComplete="off"
            prefix={<UserOutlined />}
            placeholder="Email Id"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Please enter your Password" }]}
        >
          <Input.Password
            autoComplete="off"
            prefix={<LockOutlined />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item>
          <Flex justify="space-between" align="center">
            <Button type="link" onClick={onClickForgotPassword}>
              Forgot Password
            </Button>
            {/* <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item> */}
          </Flex>
        </Form.Item>

        <Form.Item>
          <Button block type="primary" htmlType="submit" disabled={isLoading}>
            Sign in
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
